import { Box, IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function MnuControlAsistenciaActions({ handleClickRegresarMainDashboard }) {
  return (
    <Box sx={{ display: "flex", gap: 0.5 }}>
      <Tooltip title="Regresar">
        <IconButton color="primary" onClick={handleClickRegresarMainDashboard}>
          <ArrowBackIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
